<a href="javascript:void(0);" class="support text-white" (click)="createRequest()"><img src="assets/icons/support.png" alt=""></a>
